/**
 * Enum representing the available Bynder image formats
 */
export enum BynderFormats {
    WEBP_MEDIUM = '72_dpi_webp_medium',
    WEBP_MINI = '72_dpi_webp_mini',
    WEBP_MAIN = '72_dpi_webp',
    WEBP_SMALL = '72_dpi_webp_small',
    MINI = 'mini',
    WEBIMAGE = 'webimage',
}

/**
/**
/**
 * Returns a Bynder image URL with its format segment replaced by the specified new format.
 *
 * This function searches for the format segment (e.g., "webimage", "mini", "72_dpi_webp_medium", etc.)
 * in the last path component of the URL and replaces it with the provided new format.
 * If the URL does not contain a recognizable format segment, the original URL is returned.
 * If the input URL is undefined or null, the function returns undefined or null respectively.
 *
 * @param url - The original Bynder image URL. Can be a string, null, or undefined.
 * @param newFormat - The new format to use, from the BynderFormats enum.
 * @returns The image URL with the format replaced, or the original value if no replacement is possible.
 */
export function getImageUrl(
    url: string | null | undefined,
    newFormat: BynderFormats,
): string | undefined | null {
    if (url === undefined) return undefined;
    if (url === null) return null;

    // Try replacing transform/:format first
    if (url.includes('/transform/')) {
        return url.replace(/\/transform\/[^/]+/, `/transform/${newFormat}`);
    }

    // If no transform pattern, try the original format replacement
    return url.replace(/\/[^/-]+-([^/]*)$/, `/${newFormat}-$1`);
}
